var map = {
	"./blacha-plaskownik.jpg": "2939",
	"./ceownik.jpg": "a903",
	"./dwuteownik.jpg": "bbc2",
	"./katownik.jpg": "c0af",
	"./kwadrat.jpg": "5c38",
	"./pret-okragly.jpg": "3c67",
	"./pret-szesciokatny.jpg": "c8f1",
	"./profil-zamkniety.jpg": "e9b7",
	"./rura-okragla.jpg": "7ac2",
	"./rura-szesciokatna.jpg": "7b8c",
	"./teownik.jpg": "ff14"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb60";